import React, { useEffect, useState } from "react";

import AntDTable from "../AntDTable/AntDTable";
import BtnSave from "../Commons/Buttons/BtnSave";
import BtnDelete from "../Commons/Buttons/BtnDelete";
import DeleteModal from "../Modals/DeleteModal";
import VitalSignsForm from "../VitalSignsForm/VitalSignsForm";

import {
  deleteVitalSign,
  getVitalSigns,
} from "../Helpers/API/VitalSignsApi/VitalSignsApi";
import {
  formatDate,
  formatDateWithTime,
  getRole,
  formatDateTimeField,
} from "../Helpers/Utilities/Common";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";

export default function VitalSignsHistory({ id, sex, patientDetails }) {
  const role = getRole();
  const [data, setData] = useState([]);
  const [formType, setFormType] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [addVital, setAddVital] = useState({
    weight: "",
    weight_in_lb: "",
    height: "",
    height_in_ft: "",
    height_in_inc: "",
    bmi: "",
    ibw: "",
    waist: "",
    hip: "",
    whr: "",
    temperature: "",
    bp: "",
    heart_rate: "",
    respiratory_rate: "",
    oxygen_saturation: "",
    // right_eye_vision: "",
    // left_eye_vision: "",
    left_eye_w_correction: "",
    right_eye_w_correction: "",
    left_eye_wo_correction: "",
    right_eye_wo_correction: "",
    blood_type: "",
    // last_meal: "",

    length: "",
    head_circumference: "",
    skinfold_thickness: "",
    body_circumference_waist: "",
    hip_in_cm: "",
    limbs: "",
    muac: "",
  });

  // Function for adding action button in table
  function ActionBtn(row) {
    return (
      <Row className="center">
        <Col>
          <BtnSave
            id={"edit"}
            name={"edit"}
            label={"Edit"}
            size={"sm"}
            onClick={() => {
              // setSelectedRow(row.row);
              // setShowForm(true);
              // setAddVital(row.row);
              // setFormType("edit");
              setSelectedRow(row.row);
              setShowForm(true);
              setAddVital({
                ...addVital, // Preserve existing properties in addVital
                ...row.row,
                last_meal: formatDateTimeField(row?.row?.last_meal),
              });
              setFormType("edit");
            }}
            // onClick={(e) => handleActionChange(e, row.row, "edit", form)}
          />
        </Col>
        {(role === "director" || role === "pcp" || role === "specialist") && (
          <Col>
            <BtnDelete
              label={"Delete"}
              size={"sm"}
              onClick={() => {
                setSelectedRow(row.row);
                setShowDelete(true);
              }}
            />
          </Col>
        )}
      </Row>
    );
  }

  // Function delete vital signs API
  async function deleteVitalSignSubmit() {
    const res = await deleteVitalSign(selectedRow?.id);
    if (res.data) {
      toast.success(res.data.message);
      setShowDelete(false);
      setSelectedRow({});
      fetchVitalSigns();
    } else if (res.error) {
      toast.error(res.error);
    }
  }

  // Function get Vital signs
  async function fetchVitalSigns() {
    setShowLoader(true);
    const res = await getVitalSigns(id);
    if (res.data) {
      var _parsed = res.data.data.map((vs) => {
        return {
          ...vs,
          added_on: formatDateWithTime(vs.added_on),
          last_meal: vs.last_meal ? formatDateWithTime(vs.last_meal) : "",
        };
      });
      setData(_parsed);
    } else if (res.error) {
      setData([]);
    }
    setShowLoader(false);
  }

  useEffect(() => {
    fetchVitalSigns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="all-container">
      <VitalSignsForm
        id={id}
        sex={sex}
        patientDetails={patientDetails}
        addVital={addVital}
        setAddVital={setAddVital}
        showForm={showForm}
        setShowForm={setShowForm}
        formType={formType}
        setFormType={setFormType}
        fetchVitalSigns={fetchVitalSigns}
      />
      <div className="overflow">
        <AntDTable
          tableHeaders={[
            "ADDED ON",
            // "LAST MEAL",
            "TEMP (°C)",
            "HEART RATE (bpm)",
            "RESPIRATORY RATE",
            "BP (mmHg)",
            // "HEIGHT (ft)",
            "HEIGHT (cm)",
            "WEIGHT (kg)",
            "WEIGHT (lb)",
            "OXYGEN SATURATION",
            "BMI",
            "IBW (kg)",
            "WAIST (in)",
            "HIP (in)",
            "WHR",
            "LEFT EYE W/ CORRECTION",
            "RIGHT EYE W/ CORRECTION",
            "LEFT EYE W/O CORRECTION",
            "RIGHT EYE W/O CORRECTION",
            "BLOOD TYPE",
            "LENGTH (cm)",
            "HEAD CIRCUMFERENCE (cm)",
            "SKINFOLD THICKNESS (cm)",
            "BODY CIRCUMFERENCE WAIST (cm)",
            "HIP (cm)",
            "LIMBS (cm)",
            "MIDDLE UPPER ARM CIRCUMFERENCE (cm)",
          ]}
          headerSelector={[
            "added_on",

            "temperature",
            "heart_rate",
            "respiratory_rate",
            "bp",
            // "height_in_ft",
            "height",
            "weight",
            "weight_in_lb",
            "oxygen_saturation",
            "bmi",
            "ibw",
            "waist",
            "hip",
            "whr",
            "left_eye_w_correction",
            "right_eye_w_correction",
            "left_eye_wo_correction",
            "right_eye_wo_correction",
            "blood_type",

            "length",
            "head_circumference",
            "skinfold_thickness",
            "body_circumference_waist",
            "hip_in_cm",
            "limbs",
            "muac",
          ]}
          tableData={data}
          loading={showLoader}
          withAction={true}
          scroll={{ x: true }}
          isClickable={false}
          ActionBtn={(row) => ActionBtn(row)}
        />
      </div>
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        title={`Are you sure you want to delete this vital sign?`}
        onDelete={deleteVitalSignSubmit}
      />
    </div>
  );
}
